import { SectionHeader, Body } from "@sprout/typography";
import { SecondaryButton } from "@sprout/buttons";
import useTranslation from "@hooks/use_translation.ts";
import ApplicationFormHeader from "@components/job_post/application_form_header.tsx";
import { router } from "@inertiajs/react";
import type { JobPost, SearchSpecificFields } from "@/types/jben/job_post.ts";

interface Props {
  jobPost: JobPost & SearchSpecificFields;
}

export const ApplicationSuccess = ({ jobPost }: Props) => {
  const { t } = useTranslation("jobSearch");
  return (
    <>
      <ApplicationFormHeader
        title={jobPost.title}
        companyName={jobPost.company_name}
        logoUrl={jobPost.logo_url}
        publicUrl={jobPost.public_url}
        firstPublished={jobPost.first_published}
        locations={jobPost.locations}
        workType={jobPost.work_type}
        payRange={jobPost.pay_range_string ?? undefined}
      />
      <div className="flex flex-col items-start gap-4 mt-6">
        <SectionHeader as="h2">{t("applicationSuccess.header")}</SectionHeader>
        <Body>{t("applicationSuccess.body")}</Body>
        <SecondaryButton
          onClick={() => router.visit(`/jobs?query=${encodeURIComponent(jobPost.company_name)}`)}
        >
          {t("applicationSuccess.viewMoreJobs", { company: jobPost.company_name })}
        </SecondaryButton>
      </div>
    </>
  );
};
